import React from "react";

export type TemplateCategory =
  | "all"
  | "headers"
  | "hero-sections"
  | "features"
  | "pricing"
  | "call-to-action"
  | "testimonials"
  | "media";

const categories = [
  { id: "all", label: "All Templates" },
  { id: "headers", label: "Headers" },
  { id: "hero-sections", label: "Hero Sections" },
  { id: "features", label: "Features" },
  { id: "pricing", label: "Pricing" },
  { id: "call-to-action", label: "Call to Action" },
  { id: "testimonials", label: "Testimonials" },
  { id: "media", label: "Media & Gallery" },
] as const;

interface CategoryFilterProps {
  activeCategory: TemplateCategory;
  onCategoryChange: (category: TemplateCategory) => void;
}

export function CategoryFilter({
  activeCategory,
  onCategoryChange,
}: CategoryFilterProps) {
  return (
    <div className="flex flex-wrap gap-2 mb-8">
      {categories.map((category) => (
        <button
          key={category.id}
          onClick={() => onCategoryChange(category.id as TemplateCategory)}
          className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
            activeCategory === category.id
              ? "bg-volt-blue text-volt-deep-blue"
              : "bg-white/5 text-gray-400 hover:text-white hover:bg-white/10"
          }`}
        >
          {category.label}
        </button>
      ))}
    </div>
  );
}
